import { render, staticRenderFns } from "./FormalExam.vue?vue&type=template&id=13d7032f&"
import script from "./formalExam.js?vue&type=script&lang=js&"
export * from "./formalExam.js?vue&type=script&lang=js&"
import style0 from "./formalExam.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports